import common from './fr/pages/common';
import dashboard from './fr/pages/dashboard';
import account from './fr/pages/account';
import vendors from './fr/pages/vendors';
import auth from './fr/pages/auth';
import guests from './fr/pages/guests';
import budget from './fr/pages/budget';
import timeline from './fr/pages/timeline';
import subscription from './fr/pages/subscription';
import events from './fr/pages/events';
import notifications from './fr/pages/notifications';
import invitation from './fr/pages/invitation';
import collaborators from './fr/pages/collaborators';
import languages from './fr/pages/languages';
import access from './fr/pages/access';
import settings from './fr/pages/settings';
import venue from './fr/pages/venue';

import legal from './fr/pages/legal';
import achievements from './fr/pages/achievements';
import taskTemplates from './fr/taskTemplates';
import debug from './fr/debug';
import theme from './fr/theme';
import accessCode from './fr/accessCode';

export default {
  ...common,
  common,
  currentEvent: "Événement actuel",
  dashboard,
  account,
  vendors,
  auth,
  guests,
  budget,
  timeline,
  subscription,
  events,
  notifications,
  invitation,
  collaborators,
  languages,
  access,
  ...settings,
  venue,
  legal,
  achievements,
  taskTemplates,
  debug,
  theme: {
    ...theme,
    light: "Clair",
    dark: "Sombre",
    system: "Système"
  },
  accessCode
};
